import React, { useState } from 'react';
import { useLanguage } from './LanguageContext';
import { NAV_ITEMS, visibleNavItems, BOTTOM_NAV_IDS } from '../navItems';
import { MoreIcon, LogoutIcon } from './NavIcons';

/**
 * The phone navigation bar: four destinations plus More.
 *
 * Everything that does not fit on the bar lives in the More sheet, including
 * Logout — on a phone the sidebar footer that used to hold it is not on screen.
 */
const BottomNav = ({ admin, currentPage, onNavigate, onLogout }) => {
  const { print_lang } = useLanguage();
  const [sheetOpen, setSheetOpen] = useState(false);

  const barItems = BOTTOM_NAV_IDS.map((id) => NAV_ITEMS.find((item) => item.id === id));
  const sheetItems = visibleNavItems(admin).filter((item) => !BOTTOM_NAV_IDS.includes(item.id));
  const moreIsActive = !BOTTOM_NAV_IDS.includes(currentPage);

  const go = (id) => {
    setSheetOpen(false);
    onNavigate(id);
  };

  return (
    <>
      {sheetOpen && (
        <>
          <div className="more-sheet-scrim" onClick={() => setSheetOpen(false)} />
          <div className="more-sheet" role="dialog" aria-label={print_lang('nav.menu', 'Menu')}>
            <div className="more-sheet-handle" />
            <ul className="more-sheet-list">
              {sheetItems.map(({ id, labelKey, labelFallback, Icon }) => (
                <li key={id}>
                  <button
                    type="button"
                    className={`more-sheet-item ${currentPage === id ? 'active' : ''}`}
                    onClick={() => go(id)}
                  >
                    <Icon className="more-sheet-icon" />
                    {print_lang(labelKey, labelFallback)}
                  </button>
                </li>
              ))}
              <li>
                <button
                  type="button"
                  className="more-sheet-item more-sheet-item-danger"
                  onClick={() => { setSheetOpen(false); onLogout(); }}
                >
                  <LogoutIcon className="more-sheet-icon" />
                  {print_lang('nav.logout', 'Logout')}
                </button>
              </li>
            </ul>
          </div>
        </>
      )}

      <nav className="bottom-nav" aria-label={print_lang('nav.menu', 'Menu')}>
        {barItems.map(({ id, labelKey, labelFallback, Icon }) => (
          <button
            key={id}
            type="button"
            className={`bottom-nav-item ${currentPage === id ? 'active' : ''}`}
            onClick={() => go(id)}
          >
            <Icon className="bottom-nav-icon" />
            <span className="bottom-nav-label">{print_lang(labelKey, labelFallback)}</span>
          </button>
        ))}

        <button
          type="button"
          className={`bottom-nav-item ${moreIsActive ? 'active' : ''}`}
          onClick={() => setSheetOpen((open) => !open)}
          aria-expanded={sheetOpen}
        >
          <MoreIcon className="bottom-nav-icon" />
          <span className="bottom-nav-label">{print_lang('nav.more', 'More')}</span>
        </button>
      </nav>
    </>
  );
};

export default BottomNav;
